import React, { Fragment, useState } from 'react'
import styles from './ColumnPicker.module.sass'
import { ColumnConfiguration, eqHide, HideConfiguration } from '../StatisticsTable/configuration'
import Popover from '../../../etc/Popover'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import Button from '../../../controls/Button/Button'
import SettingsIcon from 'files/settings.svg'
import { pipe } from 'fp-ts/function'
import { groupBy, NonEmptyArray, tail } from 'fp-ts/NonEmptyArray'
import { values } from 'fp-ts-std/Record'
import { Checkbox } from '../../../controls/Checkbox/Checkbox'
import { difference, elem } from 'fp-ts/Array'
import { contramap, eqString } from 'fp-ts/Eq'
import clsx from 'clsx'
import { toggle } from '../../../../utils/utils'
import { Colors } from '../../../../styles'

const eqGroup = contramap((hide: HideConfiguration) => hide.group)(eqString)
const diff = difference(eqHide)

interface Props<T> {
    config: NonEmptyArray<ColumnConfiguration<T>>,
    hide: HideConfiguration[],
    onChange: (hide: HideConfiguration[]) => void,
}

const ColumnPicker = <T extends unknown>(props: Props<T>): JSX.Element => {
    const [open, setOpen] = useState(false)
    const grouped = pipe(
        props.config,
        tail,
        groupBy(column => column.group),
        values,
    )

    return <Popover
        isOpen={open}
        content={state => <ShadowContainer state={state} className={styles.content}>
            {
                grouped.map(group => <Fragment key={group[0].group}>
                    <Checkbox
                        className={styles.item}
                        color={Colors.grey}
                        value={elem(eqGroup)(group[0], diff(props.config, props.hide))}
                        onChange={checked => props.onChange(checked?
                            diff(props.hide, group):
                            props.hide.concat(group))}
                    >
                        {group[0].group}</Checkbox>
                    {
                        group.map(column => <Checkbox
                            className={clsx(styles.item, styles.subitem)}
                            color={Colors.grey}
                            key={column.name}
                            value={!elem(eqHide)(column, props.hide)}
                            onChange={() => props.onChange(toggle(eqHide)(column)(props.hide))}
                        >
                            {column.name}</Checkbox>)
                    }
                </Fragment>)
            }
        </ShadowContainer>}
    >
        <Button
            title={'Изменить видимость колонок'}
            active={open}
            onClick={() => setOpen(!open)}
        >
            <SettingsIcon/>
        </Button>
    </Popover>
}

export default ColumnPicker